import { object, string } from "yup";

import { validationMessages } from "utils/yup/validationMessages";

export const resetPasswordFormValidationSchema = object().shape({
  password: string().required(validationMessages.requiredField),
  repeatPassword: string()
    .test(
      "repeat-password",
      "Hasła nie są takie same",
      function (repeatPassword) {
        const password = this.parent.password;
        return password === repeatPassword;
      }
    )
    .required(validationMessages.requiredField),
});
